import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Popup from "../../Popups/Popup";
import { TariffPlan } from "../../enums/TariffPlan";

interface QRcode {
    Img: string,
    Name: string,
    BankName: string,
    PersonalAcc: string,
    BIC: string,
    CorrespAcc: string,
    PayeeINN: string,
    KPP: string,
    Purpose: string,
    SumRub: number,
    CurrentStep: number
}

type props = {
    isOpen: boolean;
    close: () => any;
    planId: TariffPlan;
}

const PayTariff = ({isOpen, close, planId}: props) => {

    const [buttons, setButtons] = useState(null);
    const [step, setStep] = useState(1);
    const [head, setHead] = useState(null)
    const [isFinally, setIsFinally] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [qrCode, setQrCode] = useState<any | null>(null);

    const payForWallet = async () => {
        setIsLoading(true);
        try {
            const res = await axios.post(`/api/TariffApi/PayTariffFromWallet?tariffPlanId=${planId}`);
            console.log(res);
            setIsLoading(false);
            setStep(0);
            setHead({ title: "Успех" })
            setButtons({ name: "Получить чек об оплате", action: getReceipt(res.data) })
        } catch (err) {
            console.log(err);
            setIsFinally(true);
            setHead({title: "Произошла ошибка", description: err.response?.data || "Неизвестная ошибка"})
            setIsLoading(false);
        }
    }

    const createReceipt = async () => {
        setIsLoading(true);
        try {
            const res = await axios.post(`/api/TariffApi/GenerateTariffReceipt?tariffPlanId=${planId}`);
            console.log(res.data.fileUrl);
            window.location.href = res.data.fileUrl
            setIsLoading(false);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    }

    const getReceipt = async (id) => {
        try {
            const res = await axios.get(`/api/TariffApi/GetTariffReceiptPdf?paymentId=${id}`);
            console.log(res);
        } catch (err) {
            console.log(err);
        }
    }

    const getQr = async () => {
        setIsLoading(true);
        try {
            const res = await axios.get(`/api/TariffApi/GetTariffQrCode?tariffPlanId=${planId}`);

            setIsLoading(false);
            console.log(res);
            setStep(2);
            setQrCode(res.data);
        } catch (err) {
            setIsLoading(false);
            console.log(err);
        }
    }

    const renderBody = () => (
        step ? (
            <>
                {step === 1 && step1()}
                {step === 2 && qrCode &&  
                    <>
                        <style>
                        {`
                            .paytabletr td {
                                font-family: "Montserrat";
                                font-size: 10px;
                                border: 1px solid #0000008f;
                            }


                        `}
                        </style>

                        <img src={qrCode?.ImageBase64} />
                        <table className="paytable">
                            <tr className="paytabletr">
                                <td>Получатель платежа</td><td>{qrCode.Name}</td>
                            </tr>
                            <tr className="paytabletr">
                                <td>Расчётный счет</td><td>{qrCode.PersonalAcc}</td>
                            </tr>
                            <tr className="paytabletr">
                                <td>ИНН получателя</td><td>{qrCode.PayeeINN}</td>
                            </tr>
                            <tr className="paytabletr">
                                <td>КПП получателя</td><td>{qrCode.KPP}</td>
                            </tr>
                            <tr className="paytabletr">
                                <td>Наименование банка</td><td>{qrCode.BankName}</td>
                            </tr>
                            <tr className="paytabletr">
                                <td>БИК банка</td><td>{qrCode.BIC}</td>
                            </tr>
                            <tr className="paytabletr">
                                <td>Корр. счет</td><td>{qrCode.CorrespAcc}</td>
                            </tr>
                            <tr className="paytabletr">
                                <td>Назначение платежа</td><td>{qrCode.Purpose}</td>
                            </tr>
                            <tr className="paytabletr">
                                <td>Сумма платежа</td><td>{qrCode.Sum} рублей</td>
                            </tr>
                        </table>
                    </>    
                }
            </>
        ) : (
            <></>
        )
    )

    const step1 = () => (
        <>
            <button className="defaultPinkButton" onClick={createReceipt}>Оплатить платёжкой</button>
            <button className="defaultBlackBorderButton" onClick={getQr}>Оплатить Qr-кодом</button>
            <button className="defaultPinkButton"
                onClick={payForWallet}
            >Оплатить с моего кошелька</button>
        </>
    )

    return (
        <Popup
            isOpen={isOpen}
            close={() => {
                setHead(null);
                setButtons(null);
                setIsFinally(false);
                setStep(1);
                close();
            }}
            head={head || { title: "Оплата тарифа" }}
            actionButtons={buttons}
            loading={isLoading}
            isFinally={isFinally}
            body={renderBody()}
        />
    )
}

export default PayTariff;